// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import connect from 'react-redux/lib/connect/connect';

import Slider from '../../components/Slider';
import SliderElement from '../../components/SliderElement';
import { STORE_INFO } from '../../path/storePath';
import StoreData from '../store/data/StoreData';
import { getCurrentPcId } from '../../utils/urlUtils';
import { fetchGeminiRights } from '../../state/shopping-centers/shoppingCentersService';

type Props = {
  fetchGeminiRights: Function,
}

type State = {
  currentSlideIndex: number,
}

class StoreBase extends React.Component<Props, State> {
  state: State = {
    currentSlideIndex: 0,
  };

  componentDidMount() {
    const pcId = getCurrentPcId();
    this.props.fetchGeminiRights(pcId);
  }

  render() {
    return (
      <div className="slider-container">
        <Slider
          goTopOnUpdate
          updateCurrentSlide={currentSlide =>
            this.setState({ currentSlideIndex: currentSlide })
          }
          currentSlide={this.state.currentSlideIndex}
        >
          <SliderElement path={STORE_INFO} render={<StoreData />} />
        </Slider>
      </div>
    );
  }
}

export default withRouter(connect(
  null,
  { fetchGeminiRights },
)(StoreBase));
